export type Option = {
  name: string
  value: string
}

export type Variant = {
  id: string
  selectedOptions: Option[]
  availableForSale: boolean
}

export type Product = {
  id: string
  title: string
  handle: string
  onlineStoreUrl: string
  tags: string[]
  options: {
    name: string
    optionValues: {
      name: string
    }[]
  }[]
  variants: {
    nodes: Variant[]
  }
}

export const FINAL_SALE_TAGS = ['final_sale', 'final sale']

export const extractIdFromGraphqlId = (graphqlId: string) => {
  return graphqlId ? graphqlId.split('/').pop() : ''
}

export const buildGraphqlResourceId = (id: string, resource: string) => {
  if (!id || !resource) return ''

  return `gid://shopify/${resource}/${id}`
}
